import CryptoJS from "crypto-js";

const SECRET_KEY = "sdaemon";

const encryptValue = (text: string): string => {
    return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

export const decryptValue = (cipher: string): string => {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};

/**
 * Encrypt item and make it URL-safe
 */
export function encryptItem(value: unknown): string {
    try {
        const serialized = typeof value === "string" ? value : JSON.stringify(value);
        const encrypted = encryptValue(serialized);

        // Make URL-safe: replace + and / with URL-safe characters
        const urlSafe = encrypted
            .replace(/\+/g, '-')  // Replace + with -
            .replace(/\//g, '_')   // Replace / with _
            .replace(/=+$/, '');   // Remove padding

        return urlSafe;
    } catch (error) {
        console.error("Encryption error:", error);
        return "";
    }
}

/**
 * Decrypt URL-safe encrypted item
 */
export function decryptItem<T>(cipher: string): T | null {
    try {
        if (!cipher) {
            console.error('No cipher text provided');
            return null;
        }


        // Convert back from URL-safe format
        let base64 = cipher
            .replace(/-/g, '+')   // Replace - with +
            .replace(/_/g, '/');   // Replace _ with /

        // Add padding back if needed
        while (base64.length % 4) {
            base64 += '=';
        }


        // Decrypt the restored base64 string
        const decrypted = decryptValue(base64);

        // Try to parse as JSON, otherwise return as string
        try {
            return JSON.parse(decrypted) as T;
        } catch {
            return decrypted as unknown as T;
        }
    } catch (error) {
        console.error("Decryption error:", error);
        return null;
    }
}